import React, { useState } from "react";
import {
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalTrigger,
} from "../../../../components/ui/animated-modal";
import { motion } from "motion/react";

function SoftwareInstallation() {
  const [showModal, setShowModal] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Modal>
      <div class="max-w-sm w-full lg:max-w-full shadow-lg shadow-cyan-500/50 ...">
        <div class="bg-white rounded-b lg:rounded-b-none lg:rounded-r p-4 flex flex-col justify-between leading-normal">
          <ModalTrigger className="">
            <div class="flex items-center forImage">
              <img
                class="rounded-full mr-4"
                src="https://ik.imagekit.io/ifixtechglobal/auto-Bot/checkmark.png?updatedAt=1715601130817"
                alt=""
              />
              <div class="text-lg">
                <p class="text-gray-900 leading-none">Software Installation</p>{" "}
              </div>
            </div>
          </ModalTrigger>
        </div>
      </div>

      <ModalBody>
        <ModalContent>
          <aside
            id="default-sidebar"
            class="absolute top-0 left-0 z-40 w-64 h-full transition-transform -translate-x-full sm:translate-x-0 bg-gray-50 dark:bg-gray-800"
            aria-label="Sidebar"
          >
            <div class="h-full px-3 py-4 overflow-y-auto">
              <h4 className="text-center text-base uppercase font-semibold ">
                Software List
              </h4>

              <form class="max-w-md mx-auto mb-4 mt-4">
                <label
                  htmlFor="default-search"
                  class="mb-2 text-sm font-medium text-gray-900 sr-only dark:text-white"
                >
                  Search
                </label>
                <div class="relative">
                  <div class="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none">
                    <svg
                      class="w-4 h-4 text-gray-500 dark:text-gray-400"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 20 20"
                    >
                      <path
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"
                      />
                    </svg>
                  </div>
                  <input
                    type="search"
                    id="default-search"
                    class="block w-full p-4 ps-10 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    placeholder=""
                    required
                  />
                </div>
              </form>

              <ul class="space-y-2 font-medium">
                <li className="list-decimal">
                  <a
                    href="#"
                    class="flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group"
                  >
                    <span class="">WinRAR</span>
                  </a>
                </li>
                <li className="list-decimal">
                  <a
                    href="#"
                    class="flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group"
                  >
                    <span class="flex-1 whitespace-nowrap">
                      Google Chrome / Mozilla Firefox / Microsoft Edge
                    </span>
                  </a>
                </li>

                <li className="list-decimal">
                  <a
                    href="#"
                    class="flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group"
                  >
                    <span class="">Notepad++ / Sublime Text / VS Code </span>
                  </a>
                </li>
                <li className="list-decimal">
                  <a
                    href="#"
                    class="flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group"
                  >
                    <span class="">Adobe Acrobat Reader </span>
                  </a>
                </li>
                <li className="list-decimal">
                  <a
                    href="#"
                    class="flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group"
                  >
                    <span class="">CCleaner</span>
                  </a>
                </li>
              </ul>
            </div>
          </aside>

          <div class="p-4 sm:ml-64 overflow-x-auto h-[600px]">
            <h4>Upload Software</h4>
            <div class="p-4 border-2 border-gray-200 border-dashed rounded-lg dark:border-gray-700">
              <div class="grid grid-cols-2 gap-2 mb-4">
                <div class="">
                  <h3 className="text-base font-500 uppercase font-semibold mb-2 text-center">
                    Software Verion
                  </h3>

                  <dd class="mt-2 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                    <ul
                      role="list"
                      class="divide-y divide-gray-100 rounded-md border border-gray-200 pl-0"
                    >
                      <li class="flex items-center justify-between py-2 pr-5 pl-2 text-sm/6">
                        <div class="flex w-0 flex-1 items-center">
                          <div class="ml-4 flex min-w-0 flex-1 gap-2">
                            <span class="truncate font-medium">
                              WinRAR 7.00 (February 2024)
                            </span>
                          </div>
                        </div>
                      </li>
                      <li class="flex items-center justify-between py-2 pr-5 pl-2 text-sm/6">
                        <div class="flex w-0 flex-1 items-center">
                          <div class="ml-4 flex min-w-0 flex-1 gap-2">
                            <span class="truncate font-medium">
                              WinRAR 6.24 (October 2023)
                            </span>
                          </div>
                        </div>
                      </li>
                      <li class="flex items-center justify-between py-2 pr-5 pl-2 text-sm/6">
                        <div class="flex w-0 flex-1 items-center">
                          <div class="ml-4 flex min-w-0 flex-1 gap-2">
                            <span class="truncate font-medium">
                              WinRAR 6.23 (August 2023)
                            </span>
                          </div>
                        </div>
                      </li>
                      <li class="flex items-center justify-between py-2 pr-5 pl-2 text-sm/6">
                        <div class="flex w-0 flex-1 items-center">
                          <div class="ml-4 flex min-w-0 flex-1 gap-2">
                            <span class="truncate font-medium">
                              WinRAR 6.12 (May 2022)
                            </span>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </dd>
                </div>

                <div class="">
                  <h3 className="text-base font-500 uppercase font-semibold mb-2 text-center">
                    Latest Version
                  </h3>

                  <div class="mt-2 border-t border-gray-100">
                    <dl class="divide-y divide-gray-100">
                      <div class="sm:grid sm:grid-cols-2 sm:gap-4 sm:px-0">
                        <dd class="mt-2 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                          <ul
                            role="list"
                            class="divide-y divide-gray-100 rounded-md border border-gray-200 pl-0"
                          >
                            <li class="flex items-center justify-between py-4 pr-5 pl-4 text-sm/6">
                              <div class="flex w-0 flex-1 items-center">
                                <div class="ml-4 flex min-w-0 flex-1 gap-2">
                                  <span class="truncate font-medium">
                                    WinRAR
                                  </span>
                                  <span class="shrink-0 text-gray-400">
                                    2.4
                                  </span>
                                </div>
                              </div>
                              <div class="ml-4 shrink-0">
                                <a
                                  href="#"
                                  class="font-medium text-indigo-600 hover:text-indigo-500"
                                >
                                  Download
                                </a>
                              </div>
                            </li>
                            <li class="flex items-center justify-between py-4 pr-5 pl-4 text-sm/6">
                              <div class="flex w-0 flex-1 items-center">
                                <div class="ml-4 flex min-w-0 flex-1 gap-2">
                                  <span class="truncate font-medium">
                                    WinRAR
                                  </span>
                                  <span class="shrink-0 text-gray-400">
                                    4.5
                                  </span>
                                </div>
                              </div>
                              <div class="ml-4 shrink-0">
                                <a
                                  href="#"
                                  class="font-medium text-indigo-600 hover:text-indigo-500"
                                >
                                  Download
                                </a>
                              </div>
                            </li>
                          </ul>
                        </dd>
                      </div>
                    </dl>
                  </div>
                </div>
              </div>

              <div class="flex items-center justify-center h-48 mb-4 rounded-sm bg-gray-50 dark:bg-gray-800">
                <div className="p-6">
                  <div className="relative inline-block text-left">
                    <div>
                      <button
                        type="button"
                        className="inline-flex w-full justify-center gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-xs ring-1 ring-gray-300 ring-inset hover:bg-gray-50"
                        id="menu-button"
                        aria-expanded={isOpen}
                        aria-haspopup="true"
                        onClick={() => setIsOpen(!isOpen)}
                      >
                        Select OS
                        <svg
                          className="-mr-1 h-5 w-5 text-gray-400"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                          aria-hidden="true"
                        >
                          <path
                            fillRule="evenodd"
                            d="M5.22 8.22a.75.75 0 0 1 1.06 0L10 11.94l3.72-3.72a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L5.22 9.28a.75.75 0 0 1 0-1.06Z"
                            clipRule="evenodd"
                          />
                        </svg>
                      </button>
                    </div>

                    {isOpen && (
                      <div
                        className="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5 focus:outline-none"
                        role="menu"
                        aria-orientation="vertical"
                        aria-labelledby="menu-button"
                      >
                        <div className="py-1" role="none">
                          <a
                            href="#"
                            className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                            role="menuitem"
                            id="menu-item-0"
                          >
                            Window's
                          </a>
                          <a
                            href="#"
                            className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                            role="menuitem"
                            id="menu-item-1"
                          >
                            Ubuntu
                          </a>
                          <a
                            href="#"
                            className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                            role="menuitem"
                            id="menu-item-2"
                          >
                            Mac
                          </a>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <div class="grid grid-cols-3 gap-4">
                <div class="flex items-center justify-center rounded-sm h-28 dark:bg-gray-800">
                  <div>
                    <button
                      type="button"
                      onClick={() => setShowModal(true)}
                      className=" flex w-full items-center justify-center rounded-md border border-transparent bg-indigo-600 px-8 py-3 text-base font-medium text-white hover:bg-indigo-700 focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 focus:outline-hidden"
                    >
                      Active
                    </button>
                  </div>
                </div>
                <div class="flex items-center justify-center rounded-sm h-28 dark:bg-gray-800">
                  <button class="bg-transparent hover:bg-blue-500 text-blue-700 font-semibold hover:text-black px-8 py-3  border border-blue-500 hover:border-transparent rounded">
                    De-Active
                  </button>
                </div>
                <div class="flex items-center justify-center rounded-sm h-28 dark:bg-gray-800">
                  <button class="bg-transparent hover:bg-blue-500 text-blue-700 font-semibold hover:text-black px-8 py-3  border border-blue-500 hover:border-transparent rounded">
                    Update
                  </button>
                </div>
              </div>
            </div>
          </div>

          {showModal && (
            <div
              className="fixed inset-0 z-50 flex items-center justify-center"
              role="dialog"
              aria-modal="true"
            >
              {/* Backdrop */}
              <div
                className="fixed inset-0 bg-gray-500/75"
                onClick={() => setShowModal(false)}
              ></div>

              {/* Modal Content */}
              <div className="relative z-10 w-full max-w-lg rounded-lg bg-white p-6 shadow-xl">
                <div className="items-start">
                  <ul class="text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-lg dark:bg-gray-700 dark:border-gray-600 dark:text-white">
                    <li class="list-none w-full border-b border-gray-200 rounded-t-lg dark:border-gray-600">
                      <div class="flex items-center ps-3">
                        <input
                          id="vue-checkbox"
                          type="checkbox"
                          value=""
                          class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded-sm focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500"
                        />
                        <label
                          for="vue-checkbox"
                          class="w-full py-3 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                        >
                          Admin
                        </label>
                      </div>
                    </li>
                    <li class="list-none w-full border-b border-gray-200 rounded-t-lg dark:border-gray-600">
                      <div class="flex items-center ps-3">
                        <input
                          id="react-checkbox"
                          type="checkbox"
                          value=""
                          class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded-sm focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500"
                        />
                        <label
                          for="react-checkbox"
                          class="w-full py-3 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                        >
                          All User's
                        </label>
                      </div>
                    </li>
                    <li class="list-none w-full border-b border-gray-200 rounded-t-lg dark:border-gray-600">
                      <div class="flex items-center ps-3">
                        <input
                          id="angular-checkbox"
                          type="checkbox"
                          value=""
                          class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded-sm focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500"
                        />
                        <label
                          for="angular-checkbox"
                          class="w-full py-3 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                        >
                          Single User
                        </label>
                      </div>
                    </li>
                  </ul>
                </div>

                <div className="mt-6 flex justify-end space-x-3">
                  <button
                    className="rounded-md bg-red-600 px-4 py-2 text-sm text-white hover:bg-red-500"
                    onClick={() => alert("Deactivated")}
                  >
                    Submit
                  </button>
                  <button
                    className="rounded-md border border-gray-300 bg-white px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                    onClick={() => setShowModal(false)}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          )}
        </ModalContent>
      </ModalBody>
    </Modal>
  );
}

export default SoftwareInstallation;
